// Le due formule di U Magazin. I menù a tendina verranno riempiti in seguito:
// aggiungere voci in `menu` come { name: { it, en }, description: { it, en }, price: "12" }.
export const formule = [
  {
    id: "aperitivo",
    image: "/images/plateau-crudi.webp",
    menu: [],
  },
  {
    id: "cena",
    image: "/images/gallery/z-55.webp",
    menu: [],
  },
  {
    id: "catering",
    image: "/images/gallery/z-57.webp",
    menu: [],
  },
];
